import {classes} from './css-common.st.css';

export function cssCommonExtendHitArea () {
    return classes.hitArea;
}

export function cssEllipsis () {
    return classes.ellipsis;
}

export function cssUserSelectableText () {
    return classes.userSelectableText;
}

export function cssCollapsedWhenEmpty () {
    return classes.collapsedWhenEmpty;
}

export function cssCenterInlineContent () {
    return classes.centerInlineContent;
}

export function cssMaxFullWidth () {
    return classes.maxFullWidth;
}

export function cssFullWidthAndHeight () {
    return classes.fullWidthAndHeight;
}

export function cssAbsoluteStretchInOffsetParent () {
    return classes.absoluteStretchInOffsetParent;
}